import { IMyMotionsListEntry } from "@/shared/api-client/models/motion/my-motions-list-entry";
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({

})
export default class MyMotionsStatusViewerComponent extends Vue {

    @Prop() public motion!: IMyMotionsListEntry;
    @Prop() public translations!: { [key: string]: string; };
}